import { defineComponent, h } from 'vue';
import { QBtn, QDialog } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods.js';
import BaseComponentMixin from './BaseComponentMixin.jsx';
import ControlPicker from './controlPicker.jsx';

function generateItems(control, items, model, index) {
    if (!control.controlData || !Array.isArray(control.controlData.TreeNodeTemplate))
        return;

    for (let i = 0; i < control.controlData.TreeNodeTemplate.length; i++) {
        const c = control.controlData.TreeNodeTemplate[i];
        if (!(typeof c === 'object'))
            continue;

        let DynamicControl = utils.getDesignerComponent(c, null);

        if (!c.$objectId)
            c.$objectId = utils.generateUUID();

        let id = `${c.$objectId}`;
        if (index !== null && index !== undefined)
            id += '_' + index;

        items.push(
            <div key={`row_${id}`} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <i class="mdi mdi-play" />
                <DynamicControl
                    key={id}
                    type={c.ControlType}
                    name={c.ControlData ? c.ControlData.Name : ''}
                    root={control.root}
                    designmodel={c}
                    parentType="VerticalStack"
                    controlData={c.ControlData}
                    controlURL={c.ControlURL}
                    sourceData={model}>
                </DynamicControl>
            </div>
        );
    }
}

export default defineComponent({
    name: 'basic-tree-dsgn',
    mixins: [BaseComponentMixin],
    components: {
        QBtn,
        QDialog,
        ControlPicker,
    },
    data: function () {
        return {
            model: [],
        };
    },
    created() {
        if (!Array.isArray(this.controlData.TreeNodeTemplate))
            this.controlData.TreeNodeTemplate = [];
    },
    methods: {
        ...methods,
        ensureBodyControls() {
            if (!Array.isArray(this.controlData.Controls))
                this.controlData.Controls = [];
            return this.controlData.Controls;
        },
        async Refresh() {
            if (this.controlData.SourceRaw)
                this.model = this.controlData.SourceRaw;
        }
    },
    props: {
        //name: '',
        //root: null,
        //designmodel: null,
        //parentType: '',
        //controlData: {}
    },
    mounted() {
        this.Refresh();
    },
    render() {
        let items = [];

        if (Array.isArray(this.model) && this.model.length > 0) {
            for (let i = 0; i < Math.min(this.model.length, 10); i++)
                generateItems(this, items, this.model[i], i);
        }
        else
            generateItems(this, items, null, null);

        if (this.selected$)
            items.push(
                <div class="property-grid" key="add-control">
                    {utils.tt(
                        'Add control to tree node template',
                        <QBtn size="sm" flat icon="mdi-plus-circle" color="blue-8" style={{ zIndex: 2 }} onClick={(e) => this.addControl(e, this.controlData.TreeNodeTemplate)} />
                    )}
                </div>
            );

        const style = {
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            minWidth: '25px',
            ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
            ...utils.getStyleHints(this.controlData.StyleHints),
        };

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={style}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected-clickthrough': this.selected$ }}></div>
                {items}
                {this.generatePicker(h)}
            </div>
        );
    }
});